export default __webpack_public_path__ + "static/media/GLAXO.75b72b9c.png";